/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualPrimitiveString: core.serialization.ObjectSchema<
    serializers.EqualPrimitiveString.Raw,
    Truvity.EqualPrimitiveString
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace EqualPrimitiveString {
    export interface Raw {
        value: string;
    }
}
